import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.suvaranmaranmatrimony.msdiscoveries.com',
  timeout: 30000,
});

// Attach JWT token to every request
API.interceptors.request.use(config => {
  const token = localStorage.getItem('smm_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
API.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('smm_token');
      localStorage.removeItem('smm_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
